import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { openModal } from 'store/slices/modal';
import { COOKIE_CONSENT } from 'constants/modals';
import { COOKIE_PREFERENCE_FEATURE } from 'constants/features';
import { checkForFeature } from 'utils/features';
import { cookiePreferenceSelector } from 'store/selectors/user';

const useGetUserCookiePreference = () => {
  const dispatch = useDispatch();
  const cookiePreference = useSelector(cookiePreferenceSelector);

  useEffect(() => {
    if (
      checkForFeature(COOKIE_PREFERENCE_FEATURE) &&
      cookiePreference === 'NONE'
    ) {
      dispatch(openModal({ name: COOKIE_CONSENT }));
    }
  }, [cookiePreference]);
};

export default useGetUserCookiePreference;
